class HydrantQuickProduct extends HTMLElement {
	constructor() {
		super()
		this.variantsSelector = this.querySelector(".variants-switcher")
		this.variantIdSelector = this.querySelector("input[name='id']")
		this.purchaseMethod = this.querySelector("input[name='selling_plan']")
		this.form = this.querySelector("form")
		this.reviewsOverall = this.querySelector(".reviews-overall")
		this.scorePreview = this.querySelector(".score-preview")
	}

	connectedCallback() {
		this.overAllReviews(this.getAttribute("id"))
		this.variantsSelector.addEventListener("change", $event => {
			console.log($event.target.value)
			this.variantIdSelector.value = $event.target.value
		})
		this.purchaseMethod.addEventListener("change", $event => {
			if ($event.target.checked) {
				this.querySelector(".product-original-price").classList.add("line-through")
				this.querySelector(".product-discounted-price").classList.remove("hidden")
				return
			}
			this.querySelector(".product-original-price").classList.remove("line-through")
			this.querySelector(".product-discounted-price").classList.add("hidden")
		})
		this.form.addEventListener("submit", $event => {
			$event.preventDefault()
			const formData = new FormData($event.target)
			const formObject = {}
			formData.forEach(function (value, key) {
				formObject[key] = value
			})

			fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formObject),
			})
				.then(response => response.json())
				.then(response => {
					Rebuy.SmartCart.show()
				})
		})
	}

	formatNumber(number) {
		return number.toLocaleString("en-US")
	}

	async overAllReviews(id) {
		try {
			const reviews = await fetch(`https://api.okendo.io/v1/stores/c3585e68-d5a0-4cc4-94a4-37af5ea9c660/products/shopify-${id}/review_aggregate`).then(response => response.json())
			const score = reviews.reviewAggregate.ratingAndReviewValuesTotal / reviews.reviewAggregate.ratingAndReviewCount.toFixed(1)
			const scorePercentage = (score / 5) * 100
			this.reviewsOverall.textContent = `( ${this.formatNumber(reviews.reviewAggregate.ratingAndReviewCount)} )`
			this.scorePreview.classList.add(`w-[${scorePercentage}%]`)
			this.reviewsOverall.classList.remove("hidden")
			this.scorePreview.classList.remove("hidden");
			
		} catch (error) {}
	}
}

customElements.define("hydrant-quick-product", HydrantQuickProduct)
